/**
 * Parse and convert custom link formats to Markdown
 * Supports:
 * 1. Plain URLs: https://example.com -> [https://example.com](https://example.com)
 * 2. Custom format: {link:https://example.com|Click here} -> [Click here](https://example.com)
 */

const CUSTOM_LINK_REGEX = /\{link:(https?:\/\/[^\s|]+)\|([^}]+)\}/g;
const URL_REGEX = /(https?:\/\/[^\s\]]+)/g;

export const parseLinks = (text) => {
  if (!text) return text;
  
  let parsed = text;
  
  // First, convert custom link format to markdown: {link:URL|Text} -> [Text](URL)
  parsed = parsed.replace(CUSTOM_LINK_REGEX, (match, url, linkText) => {
    return `[${linkText}](${url})`;
  });
  
  // Then, convert plain URLs to markdown: URL -> [URL](URL)
  // But skip URLs that are already in markdown format [text](URL)
  parsed = parsed.replace(URL_REGEX, (url) => {
    // Check if this URL is already part of a markdown link
    const beforeUrl = parsed.substring(0, parsed.indexOf(url));
    const afterUrl = parsed.substring(parsed.indexOf(url) + url.length);
    
    // If preceded by ]( or followed by ), it's already a markdown link
    if (beforeUrl.endsWith('](') || afterUrl.startsWith(')')) {
      return url;
    }
    
    return `[${url}](${url})`;
  });
  
  return parsed;
};

export default parseLinks;
